import { getTotalGrossPrice } from '~~/helpers/cart/getTotalPricesModule';
import { getBasketPartnersPoints } from '~~/helpers/loyaltyPoints/getBasketPartnersPoints';
import type { BasketPartnersPoints } from '~~/helpers/loyaltyPoints/getBasketPartnersPoints';

export const useBasketPartnersPoints = () => {

  const { cart } = useCartExtended();
  const { isLoggedIn } = useUserExtended();
  const { isLoyaltyDiscountEnabled } = useStoreVsfExtended();
  const { ratio, partnersLevels, load: loadPartnersLevels } = useCDPLoyaltyLevels();
  const {
    loyaltyPoints,
    loading: loyaltyPointsLoading,
    error: loyaltyPointsError,
    load: loadLoyaltyPoints,
  } = useLoyaltyPoints();

  const basketPoints = computed<BasketPartnersPoints | null>(() => {

    const basketTotal = getTotalGrossPrice(cart.value);

    // waits for the customer's points, so the text does not change after it has appeared
    if (!isLoggedIn.value || loyaltyPointsLoading.value || !ratio.value || !basketTotal) {

      return null;

    }

    return getBasketPartnersPoints({
      basketTotal,
      ratio: ratio.value,
      currentPoints: loyaltyPointsError.value ? null : loyaltyPoints.value?.points ?? null,
      levels: partnersLevels.value,
    });

  });

  const loadPartnersData = () => {

    if (!isLoyaltyDiscountEnabled.value) {

      return;

    }

    loadPartnersLevels();

    if (isLoggedIn.value) {

      loadLoyaltyPoints();

    }

  };

  onMounted(loadPartnersData);
  watch(isLoggedIn, loadPartnersData);

  return {
    basketPoints,
  };

};
